import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import { IErrorActionData } from '../../../models/Error';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';
import {
  IInitiateCartPaymentActionTypes, InitiateCartPaymentAction, initiateCartPaymentFailure, initiateCartPaymentSuccess,
} from '../actions/InitiateCartPayment';
import initiateCartPaymentService from '../services/InitiateCartPayment';

const InitiateCartPaymentEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(IInitiateCartPaymentActionTypes.INITIATE_CART_PAYMENT)),
  mergeMap((action: InitiateCartPaymentAction) => from(
    initiateCartPaymentService(action.payload),
  ).pipe(
    map((response) => initiateCartPaymentSuccess(response.data)),
    catchError((error: IErrorActionData) => of(
      initiateCartPaymentFailure({
        errorCode: error.errorCode || 500,
        errorMessage: error.errorMessage,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default InitiateCartPaymentEpic;
